import { RootState } from '../store'

export const countriesSelector = (state: RootState) => {
  const { countries } = state

  return countries
}
